import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../config/config.service';
import { TipoAnalise } from '../../../../types/TipoAnalise.type';

@Injectable({
  providedIn: 'root'
})
export class AnalisePesagemService {

  private readonly basePath = '/pesagem-balanca/tipo-analise';

  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  findAll(instancia?: string): Observable<TipoAnalise[]> {
    const params: any = {};
    if (instancia) params['instancia'] = instancia;
    return this.httpClient.get<TipoAnalise[]>(`${this.configService.getApiUrlRoot()}${this.basePath}`, { params });
  }

  findById(id: string): Observable<TipoAnalise> {
    return this.httpClient.get<TipoAnalise>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`);
  }

  create(tipoAnalise: TipoAnalise): Observable<TipoAnalise> {
    return this.httpClient.post<TipoAnalise>(`${this.configService.getApiUrlRoot()}${this.basePath}`, tipoAnalise);
  }

  update(id: string, tipoAnalise: TipoAnalise): Observable<TipoAnalise> {
    return this.httpClient.put<TipoAnalise>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`, tipoAnalise);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.configService.getApiUrlRoot()}${this.basePath}/${id}`);
  }

  findAtivos(instancia?: string): Observable<TipoAnalise[]> {
    const params: any = {};
    if (instancia) params['instancia'] = instancia;
    return this.httpClient.get<TipoAnalise[]>(`${this.configService.getApiUrlRoot()}${this.basePath}/ativos`, { params });
  }

  verificarPermitido(remessa: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.configService.getApiUrlRoot()}${this.basePath}/permitido/${remessa}`);
  }

  verificarPermitidoLacre(remessa: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.configService.getApiUrlRoot()}${this.basePath}/permitido-lacre/${remessa}`);
  }

  exibirLacre(remessa: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.configService.getApiUrlRoot()}${this.basePath}/exibir-lacre/${remessa}`);
  }

  obrigatoriedadeLacre(remessa: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.configService.getApiUrlRoot()}${this.basePath}/obrigatoriedade-lacre/${remessa}`);
  }
}
